import apiMiddleware from "../../../api/apiMiddleware";
const login = async (credentials) => {
  const response = await apiMiddleware.post("/auth/login/admin", credentials);
  return response.data;
};

export { login };
